/*
 * The brand this page was served for, or null on a single-brand deployment.
 *
 * The server puts it in the document as inert JSON (see
 * server/lib/brandRuntime.js). Read once at module load: the block is in
 * <head>, and module scripts are deferred, so it is always there before any
 * of this runs. Anything unreadable falls back to the built-in brand rather
 * than breaking the page.
 */
export const RUNTIME_BRAND = (() => {
  try {
    if (typeof document === "undefined") return null;
    const el = document.getElementById("pf-brand");
    if (!el) return null;
    const parsed = JSON.parse(el.textContent || "null");
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;   // a malformed brand must not take the page down
  }
})();
